import React, { useState } from "react";
import cn from "classnames";
import styles from "./NameAndDescription.module.sass";

// Screens
import StudentInformations from "./StudentInformations";
import StudyInformations from "./StudyInformations";
import ContactInformations from "./ContactInformations";

// Services
import { updateProspect, getProspectById } from "../../../services/prospect.service";
import { showSuccess, showError } from "../../../services/toast.service";

const NameAndDescription = ({ prospect }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [prospectData, setProspectData] = useState(prospect || {});
  const [isMinor, setIsMinor] = useState(false);
  const [modified, setModified] = useState(false);

  // Mettre à jour les données du prospect quand le prop change
  React.useEffect(() => {
    if (prospect) {
      setProspectData(prospect);
    }
  }, [prospect]);

  const handleProspectChange = (e) => {
    const { name, value } = e.target;
    setProspectData((prev) => ({ ...prev, [name]: value }));
    setModified(true);

    if (name === "birth_date") {
      if (value) {
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setIsMinor(age < 18);
      } else {
        setIsMinor(false);
      }
    }
  };

  const handleSwitchChange = (name, value) => {
    setProspectData((prev) => ({ ...prev, [name]: value }));
    setModified(true);
  };

  const handleDropdownChange = (name, value) => {
    setProspectData((prev) => ({ ...prev, [name]: value }));
    setModified(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await updateProspect(prospectData.id, prospectData);
      
      // Rafraîchir les données du prospect après la mise à jour
      try {
        const refreshedProspect = await getProspectById(prospectData.id);
        setProspectData(refreshedProspect);
        console.log('Données du prospect rafraîchies après mise à jour');
      } catch (refreshError) {
        console.error('Erreur lors du rafraîchissement des données:', refreshError);
        // Ne pas faire échouer l'opération si le rafraîchissement échoue
      }
      
      showSuccess("Prospect mis à jour avec succès!");
      setModified(false);
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour le prospect: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formContainer}>
        {error && <div className={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <StudentInformations
            prospect={prospectData}
            onProspectChange={handleProspectChange}
            onDropdownChange={handleDropdownChange}
            onSwitchChange={handleSwitchChange}
          />
          <ContactInformations
            prospect={prospectData}
            onProspectChange={handleProspectChange}
            onDropdownChange={handleDropdownChange}
          />
          <StudyInformations
            prospect={prospectData}
            onProspectChange={handleProspectChange}
            onDropdownChange={handleDropdownChange}
            onSwitchChange={handleSwitchChange}
          />
        </form>
      </div>
    </div>
  );
};

export default NameAndDescription;
